import * as React from 'react'

// Components
import Svg from './..'

const Turtle = (props) => {
  return (
    <Svg fill="none" viewBox="0 0 16 10" {...props}>
      <path
        d="M13.31 3.841c-.811.455-.786 1.567-2.77 3.054-.484.362.511 2.262.08 2.686-.438.431-2.195.452-2.62.217-.625-.346-.135-1.25.005-2.57-1.281.127-1.696.106-2.984.054.196 1.001.484 2.114.067 2.481-.34.299-1.99.331-2.507.004-.646-.41.468-2.74.09-2.779-.434-.043-3.084.058-2.616-2.735.496.704 1.344 1.366 2.317 1.069.133-2.37 1.613-4.5 3.975-4.5s4.032 1.779 4.045 3.984c1.399-1.02.37-3.527 2.047-4.464 1.193-.668 2.589-.323 3.254.735.348.552.456 1.526.026 2.06-.642.797-1.853.392-2.41.704z"
        fill="#ff9545"
      />
    </Svg>
  )
}

export default Turtle
